import React, { useRef } from "react";
import { useParams } from "react-router-dom";
import FBLoader from "../../atoms/FBLoader/FBLoader";
import SlimMap from "../../atoms/SlimMap/SlimMap";
import Layout from "../../atoms/Layout/Layout";
import useQuery from "../../hooks/useQuery";
import { useUser } from "../../hooks/useUser";
import { DumnDot } from "../../atoms/FullMap/FullMap";
import { CatmullRomLine } from "@react-three/drei";
import PointSearchList from "../../atoms/PointSearchList/PointSearchList";
import DNDList from "../../atoms/DNDList/DNDList";

import LanguageSwitch from "../../atoms/LanguageSwitch/LanguageSwitch";
import useTranslateDocument from "../../hooks/useTranslateDocument";
import Spacer from "../../atoms/Spacer/Spacer";

import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

import Label from "../../atoms/Label/Label";
import "./TourExponateEdit.scss";

export default function TourExponateEdit() {
  let { tourId } = useParams();
  let { user } = useUser();
  let { mappedResults } = useQuery("exhibits", "user", "==", user.uid);

  let { data: client } = useTranslateDocument("clients/" + user.uid);
  let {
    data: tourData,

    status,

    setField,
  } = useTranslateDocument("/tours/" + tourId);
  return (
    <Layout className="TourExponateEdit">
      <LanguageSwitch>
        <div className="outerWrapper">
          <div className="canvasWrapper">
            {mappedResults &&
              mappedResults.length > 0 &&
              client &&
              client.floorplan && (
                <SlimMap floorplan={client.floorplan}>
                  {mappedResults
                    .filter((r) => {
                      return r.point;
                    })
                    .map((r) => {
                      return (
                        <DumnDot
                          key={r.id}
                          onClick={() => {
                            if (!r.isPOI && !tourData.points.includes(r.id)) {
                              setField(
                                "points",
                                [...tourData.points, r.id],
                                true
                              );
                            }
                          }}
                          data={r}
                        ></DumnDot>
                      );
                    })}

                  {tourData.points.filter((id) =>
                    mappedResults.find((p) => p.id === id && p.point)
                  ).length > 1 && (
                    <Line
                      points={tourData.points
                        .filter((id) =>
                          mappedResults.find((p) => p.id === id && p.point)
                        )
                        .map((id) => {
                          let point = mappedResults.find((p) => p.id === id);

                          return (point && point.point) || null;
                        })

                        .map((o) => {
                          return [o.x, o.y, o.z];
                        })}
                    ></Line>
                  )}
                </SlimMap>
              )}
          </div>
          <div className="lists">
            <FBLoader status={status}>
              {tourData && tourData.points && (
                <>
                  <PointSearchList
                    points={mappedResults.filter(
                      (v) => !tourData.points.includes(v.id) && v.point
                    )}
                    onPointClicked={(v) => {
                      //add to tour.
                      if (!tourData.points.includes(v.id)) {
                        setField("points", [...tourData.points, v.id], true);
                      }
                    }}
                  ></PointSearchList>
                  <Spacer h={12}></Spacer>
                  <Label>Punkte der Tour anordnen</Label>
                  <Spacer h={12}></Spacer>
                  <DNDList
                    hasTexts={tourData.isTreasureHunt}
                    pointTexts={tourData.pointTexts}
                    pointImages={tourData.pointImages}
                    setPointImages={(p, t) => {
                      setField("pointImages", {
                        ...tourData.pointImages,
                        [p]: t,
                      });
                    }}
                    setPointText={(p, t) => {
                      setField("pointTexts", {
                        ...tourData.pointTexts,
                        [p]: t,
                      });
                      /* setLocalTour({
                            ...localTour,
                            pointTexts: { ...localTour.pointTexts, [p]: t },
                          });*/
                    }}
                    value={tourData.points
                      .filter((id) =>
                        mappedResults.find((p) => p.id === id && p.point)
                      )
                      .map((id) => {
                        let point = mappedResults.find((p) => p.id === id);
                        return point;
                      })}
                    onChange={(l) => {
                      setField(
                        "points",
                        l.map((i) => i.id),
                        true
                      );
                    }}
                  ></DNDList>

                  <Spacer h={12}></Spacer>
                </>
              )}
            </FBLoader>
          </div>
        </div>
      </LanguageSwitch>
    </Layout>
  );
}

function Line({ points }) {
  let ref = useRef();

  return (
    <CatmullRomLine
      ref={ref}
      points={points} // Array of Points
      closed={false} // Default
      curveType="centripetal" // One of "centripetal" (default), "chordal", or "catmullrom"
      color="green" // Default
      lineWidth={5}
      segments={1000}
      dashed={false} // Default
    ></CatmullRomLine>
  );
}
